module.exports = __webpack_public_path__ + "img/tech@8x.b6d5fadb.png";